import React, { useContext } from "react";
import { rootStoreContext } from "../context";

const useStores = () => {
	return useContext(rootStoreContext).stores;
};

export default useStores;
